import { Injectable, EventEmitter } from '@angular/core';
import configApp from 'psapp-config';
import { CookieService } from 'ngx-cookie-service';
import { LoginProvider } from 'providers/login/login';
import { environment } from 'environments/environment';

declare var window: any;

@Injectable()
export class AppService {

    onMainMenuEvent = new EventEmitter();

    constructor(
        private loginProvider: LoginProvider,
        public cookieService: CookieService
    ) { }

    url2contentId(url: string) {
        var contentId = null;
        if (url) {
            var page = url.replace(/\./g, "_").replace(/\s/g, "_").replace(/\//g, ".").replace(/\.{2,}/g, ".").toLowerCase().split(";")[0];
            if (page && page !== ".") {
                contentId = configApp.webTrekkPagePrefix + page;
            }
        }
        return contentId;
    };

    InitWebTrekk(){
        this.SetSentUrmCategory("0");
        window._tiConfig = window._tiConfig || {
            tiDomain: 'responder.wt-safetag.com',
            tiId: environment.webTrekkTiId,
            //customDomain: 'sub.domain.tld',
            //customPath: 'js/container_script.js',          
            option: {}
        };
        
        //TagIntegration loader
        window._webTrekkInit(window,document,"script",window._tiConfig);
    }

    GetWebTrekkCookieParams() {
        var customerId = this.loginProvider.isLogged() ? this.loginProvider.userId : ''
        var urmCategory: any = '';

        var webTrekkCookie = this.cookieService.get("WebTrekk_Cookie");

        if (webTrekkCookie != null) {
            var values = decodeURIComponent(webTrekkCookie).split(";");
            customerId = values[0];

            urmCategory = {};
            for (var i = 1; i < values.length; i++) {
                urmCategory[i] = values[i];
            }
        }
        return {
            customerId: customerId,
            urmCategory: urmCategory
        }
    }

    SetSentUrmCategory(sent:string = "0"){
        sessionStorage.setItem("sentUrmCategory", sent);
    }

    SetWebTrekkPageView(url: string) {
        
        var siteURL = url == "/" ? "/home" : url;
        
        var contentId = this.url2contentId(siteURL);
        if (contentId) {
            var cookieParams = this.GetWebTrekkCookieParams();
            
            //console.log("PAGE contentId: " + contentId, " / customerId: " + cookieParams.customerId, " / urmCategory: " + cookieParams.urmCategory);
            /*
            window._ti = window._ti || {};
            window._ti["contentId"] = contentId;
            window._ti["customerId"] = cookieParams.customerId;
            if(cookieParams.urmCategory)
                window._ti['urmCategory'] = cookieParams.urmCategory;
            */
            var contentGroups = {};
            var contentGroup = contentId.split(".");
            //do not send last group 
            for (var i = 0; i < contentGroup.length; i++) {
                contentGroups[i + 1] = contentGroup[i];
            }
            var webTrekkContent:any = {
                contentId: contentId, //Page Name
                customerId: cookieParams.customerId, //Custom visitor IDs
                //customParameter: '', //Page parameters
                contentGroup: contentGroups,  //Content groups
            };

            //URM categories
            if(sessionStorage.getItem("sentUrmCategory") != "1" && cookieParams.urmCategory != ""){
                webTrekkContent.urmCategory = cookieParams.urmCategory;
                this.SetSentUrmCategory("1");
            }

            // Send a page call
            window.wts.push([
                'send',
                'page',
                webTrekkContent
            ]);

            //console.log("webTrekkContent:", webTrekkContent);
        }
    }
}
